import { inject, provideAppInitializer } from '@angular/core'
import { Location } from '@angular/common'

import { getLocalStorage, removeLocalStorage, STORAGE_KEYS } from '@utils/storage'
import { TicketInfo } from '@definitions/ticket'
import { TicketInfoState } from '@states/ticket-info'
import { AppRoutes } from '@enums/app-routes'

export const ticketInfoInitializer = provideAppInitializer(() => {
	const location = inject(Location)
	const ticketInfoState = inject(TicketInfoState)
	const ticketInfo = getLocalStorage<TicketInfo>(STORAGE_KEYS.TICKET_INFO)
	const currentUrl = location.path()

	if (currentUrl !== AppRoutes.Payment) {
		removeLocalStorage(STORAGE_KEYS.TICKET_INFO)

		return
	}

	ticketInfoState.ticketInfo.set(ticketInfo)
})
